<template>
  <div>
    <b-row>
      <b-col cols="12">
        <router-view></router-view>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "BusinessAnnualReturnsTab",

}
</script>

<style scoped>

</style>